import Api from "./Api";
import store from "../state/store";

export default {
  getCustomField(userTypeId, userId) {
    return Api().get(`section/custom_field/${userTypeId}/list/${userId}`);
  },
  getCustomFieldByAreaId(payload) {
    return Api().get(
      `section/custom_field_visits/${payload.userTypeId}/${payload.areaId}/list/${payload.userId}`
    );
  },
  getMainSectionTitle() {
    return Api().get(
      `section/main_section_by_entity/${store.getters["authfack/currentEntity"].id}/name`
    );
  },
  getSectionDataForDailylog(scanId) {
    return Api().get(
      `section/custom_field_scan/list/${scanId}/${store.getters["authfack/currentEntity"].id}`
    );
  },
  updateSectionDataForDailylog(scanId, customFieldPayload) {
    //replace entity id with entity user id (#TODO from backend)
    return Api().post(
      `scan/update_custom_fields/${scanId}/${store.getters["authfack/currentEntity"].id}`,
      customFieldPayload
    );
  },
};
